import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypescriptDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 59,
	viewBox: "0 0 58 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5 5.25381H53V53.2538H5V5.25381ZM33.56 44.8805C34.3429 46.3617 35.5371 47.5851 36.999 48.4036C38.4608 49.222 40.128 49.6006 41.8 49.4938C46.0667 49.4938 49.2667 47.2805 49.2667 43.2005C49.2667 39.1205 47.1067 37.8671 43.2667 36.1071L42.1467 35.6271C40.2 34.8005 39.48 34.2405 39.48 32.9605C39.4825 32.6871 39.5417 32.4172 39.654 32.168C39.7662 31.9187 39.9291 31.6954 40.1322 31.5124C40.3352 31.3294 40.5741 31.1906 40.8337 31.1047C41.0933 31.0189 41.3678 30.9879 41.64 31.0138C42.2644 31.007 42.8762 31.1893 43.395 31.5368C43.9137 31.8842 44.3152 32.3806 44.5467 32.9605L48.04 30.6405C47.4352 29.4897 46.5072 28.5408 45.3701 27.9107C44.2329 27.2805 42.9364 26.9966 41.64 27.0938C40.8074 27.0123 39.9669 27.1051 39.1721 27.3662C38.3773 27.6273 37.6456 28.0511 37.0235 28.6105C36.4014 29.1698 35.9026 29.8526 35.5588 30.6153C35.215 31.378 35.0338 32.2039 35.0267 33.0405C35.0267 36.7205 37.1867 38.3738 40.36 39.8405L41.48 40.3205C43.56 41.2271 44.7867 41.7872 44.7867 43.3338C44.7867 44.8805 43.5867 45.5471 41.72 45.5471C40.802 45.5666 39.8971 45.3267 39.1094 44.855C38.3216 44.3833 37.6829 43.6989 37.2667 42.8805L33.5867 45.0138M31.6667 27.2538H17.5047V31.2538H22.3333V49.4938H27V31.2538H31.6667V27.2538Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTypescriptDark);
export { ForwardRef as ReactComponent };
